import apiClient from './client';

export const appointmentFlowApi = {
  getBranches: (params) => apiClient.get('/api/branches', { params }),
  createBranch: (data) => apiClient.post('/api/branches', data),
  updateBranch: (id, data) => apiClient.put(`/api/branches/${id}`, data),
  deleteBranch: (id) => apiClient.delete(`/api/branches/${id}`),
  getServices: (params) => apiClient.get('/api/services', { params }),
  createService: (data) => apiClient.post('/api/services', data),
  updateService: (id, data) => apiClient.put(`/api/services/${id}`, data),
  deleteService: (id) => apiClient.delete(`/api/services/${id}`),
  getEmployees: (params) => apiClient.get('/api/employees', { params }),
  createEmployee: (data) => apiClient.post('/api/employees', data),
  updateEmployee: (id, data) => apiClient.put(`/api/employees/${id}`, data),
  deleteEmployee: (id) => apiClient.delete(`/api/employees/${id}`),
  addBranchService: (data) => apiClient.post('/api/branch-services', data),
  removeBranchService: (data) => apiClient.delete('/api/branch-services', { data }),
  getServiceEmployees: (params) => apiClient.get('/api/service-employees', { params }),
  addServiceEmployee: (data) => apiClient.post('/api/service-employees', data),
  removeServiceEmployee: (data) => apiClient.delete('/api/service-employees', { data }),
  getAvailableSlots: (data) => apiClient.post('/api/available-slots', data),
  createAppointment: (data) => apiClient.post('/api/appointments', data),
  getFlowMessages: () => apiClient.get('/api/appointment-flow/messages'),
  updateFlowMessages: (data) => apiClient.put('/api/appointment-flow/messages', data),
};

export default appointmentFlowApi;
